import { Box, useTheme } from '@mui/material';
import { Logo } from '../../icons/Logo/Logo';
import { brandOverride } from '../../clients/brandOverride';
import { Text } from '../../components/Text/Text';
import { Heading } from '../../components/Heading/Heading';
import Countdown from 'react-countdown';
import { useChallengeStartTime } from '../../hooks/useChallengeStartTime/useChallengeStartTime';
import { useNavigate } from 'react-router-dom';
import { APP_PATHS } from '../../constants/paths';
import { Copy } from '../../copy/Copy';
import { dynamicTextColor } from '../../helpers/dynamicTextColor';
import { Reload } from '../../icons/Reload/Reload';
import { Button } from '../../components/Button/Button';
import { useWindowSize } from '../../hooks/useWindowSize/useWindowSize';
import {
  buttonContainerSx,
  countdownSx,
  logoContainerSx,
  reloadButtonSx,
  signUpHoldingContainerSx,
  titleSx,
  xLogoSx,
} from './SignUpHolding.style';
import { marginBottom16Sx } from '../../styles/Global.style';

export const SignUpHolding = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { challengeStartTime, setIsSignUpPeriod } = useChallengeStartTime();
  const { windowSize } = useWindowSize();

  const navToProfile = () => {
    setIsSignUpPeriod(false);
    navigate(APP_PATHS.profile);
  };

  return (
    <Box component="section" sx={signUpHoldingContainerSx(windowSize.height)}>
      <Box sx={logoContainerSx}>
        <Logo />
        <Text text="x" sx={xLogoSx} />
        {brandOverride().logo}
      </Box>

      <Box component="div" sx={countdownSx(theme, brandOverride().font)}>
        <Countdown date={challengeStartTime} onComplete={navToProfile} />
      </Box>

      <Box component="div" sx={marginBottom16Sx}>
        <Heading
          level={2}
          text={Copy.inject('SignUpHolding.title', {
            getSet: dynamicTextColor(
              'get set...',
              theme.palette.quaternary.main,
            ),
          })}
          color={theme.palette.secondary.main}
          sx={titleSx}
        />

        <Text
          text={Copy.inject('SignUpHolding.content', {
            startDate: brandOverride().startDate,
            challengeDistance: brandOverride().challengeDistance,
          })}
          sx={marginBottom16Sx}
        />

        <Heading
          level={2}
          text={Copy.generate('SignUpHolding.install.heading')}
          color={theme.palette.tertiary.main}
          sx={marginBottom16Sx}
        />
        <Text text={Copy.generate('SignUpHolding.install.content')} />
      </Box>

      <Box sx={buttonContainerSx}>
        <Button
          startIcon={<Reload />}
          onClick={() => location.reload()}
          sx={reloadButtonSx(theme)}
          fullWidth
          text={Copy.generate('Buttons.reload')}
        />
      </Box>
    </Box>
  );
};
